<template>
  <div>
    <page-header heading="Payments" breadcrumb="Settings  >>  Payments" />

    <div class="shadow-lg p-3 rounded mt-8">
      <p class="mb-4">
        Select and set up preferred payment methods for your shipments
      </p>
      <div class="flex border-b border-gray-500 mb-3">
        <div class="p-3 w-7/12">
          <h5 class="font-semibold text-lg mb-3">Wallet</h5>
        </div>
        <div class="p-3 w-5/12 text-right">
          <!-- @click="$router.push('/settings/wallet-details')" -->
          <button
            class="inline-flex items-center"
            @click="$router.push('/settings/wallet-details')"
          >
            <i :class="[isWalletShow ? 'rotate-right' : 'rotate-back']"
              ><img class="ml-2" src="@/assets/images/icons/arrow-right.svg"
            /></i>
          </button>
        </div>
      </div>

      <div class="flex border-b border-gray-500 mb-3">
        <div class="p-3 w-7/12">
          <h5 class="font-semibold text-lg mb-3">Card</h5>
          <div v-if="isCardShow">
            <div v-if="isDefaultCard">
              <p>{{ userName }}</p>
              <p>
                Visa Card ID #:
                <b
                  >**** **** ****
                  {{
                    DefaultCard.cardNumber.slice(
                      DefaultCard.cardNumber.length - 4,
                      DefaultCard.cardNumber.length
                    )
                  }}</b
                >
              </p>
            </div>
            <div v-else>
              <p>
                You can add a debit card to your account. Your card will be
                charged each time you make a new shipment booking. This is a
                secured service offered in partnership with Paystack.
              </p>
            </div>
          </div>
        </div>
        <div class="p-3 w-5/12 text-right">
          <button
            v-if="!isDefaultCard"
            @click="$router.push('/settings/cards')"
            class="rounded bg-primary-navy text-white py-2 px-4"
          >
            Add
          </button>
          <button v-else class="inline-flex items-center">
            <span
              class="p-2 px-3 rounded-sm bg-primary-navy text-white mr-2"
              @click="$router.push('/settings/cards')"
              >View Detail</span
            >
            <i :class="[isCardShow ? 'rotate-right' : 'rotate-back']"
              ><img
                @click="isCardShow = !isCardShow"
                class="ml-2"
                src="@/assets/images/icons/arrow-right.svg"
            /></i>
          </button>
        </div>
      </div>

      <div class="flex border-b border-gray-500 mb-3">
        <div class="p-3 w-7/12">
          <h5
            class="font-semibold text-lg mb-3"
            @click="makeDefaultwallet = true"
          >
            Pay-on-Demand
          </h5>
          <p>
            You can opt to pay on demand by manually entering your card
            information each time you need to complete a shipment booking.
          </p>
        </div>
        <div class="p-3 w-5/12 text-right">
          <el-switch disabled v-model="onDemand" />
        </div>
      </div>

      <div class="flex border-b border-gray-500 mb-3">
        <div class="p-3 w-7/12">
          <h5 class="font-semibold text-lg mb-3">Cash on Pick-Up</h5>
          <p>
            You can opt to pay on demand by manually entering your card
            information each time you need to complete a shipment booking.
          </p>
        </div>
        <div class="p-3 w-5/12 text-right">
          <el-switch disabled v-model="onPickUp" />
        </div>
      </div>
    </div>
    <MakeDefaultwallet
      :showModal="makeDefaultwallet"
      @closeModal="makeDefaultwallet = false"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader.vue";
import MakeDefaultwallet from "@/components/Ondemand/Settings/Modal/MakeDefaultwallet.vue";

export default {
  data() {
    return {
      onDemand: false,
      onPickUp: false,
      fundWallet: false,
      userCards: [],
      userWallet: {},
      isWalletShow: false,
      isCardShow: false,
      hasWallet: false,
      makeDefaultwallet: false,
    };
  },
  components: {
    PageHeader,
    MakeDefaultwallet,
  },
  mounted() {
    this.getUserCards();
    this.getUserWalletDetails();
  },
  computed: {
    userName() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      return user?.firstname + " " + user?.lastname;
    },
    isDefaultCard() {
      return this.userCards.filter((item) => item.isDefault).length;
    },
    DefaultCard() {
      return this.userCards.filter((item) => item.isDefault)[0];
    },
  },
  methods: {
    async showwalletFunction() {
      this.hasWallet ? await this.activateWallet() : (this.fundWallet = true);
    },
    async getUserCards() {
      try {
        const response = await this.$_getUsersCard();
        this.userCards = response.data.userCards;
      } catch (error) {
        this.handleError(error);
      }
    },
    async activateWallet() {
      try {
        await this.$_activateWallet();
        await this.getUserWalletDetails();
      } catch (error) {
        this.handleError(error)
      }
    },
    async getUserWalletDetails() {
      try {
        const response = await this.$_getUserWallet(
          localStorage.getItem("userId")
        );
        this.userWallet = response.data.userWallet;
        this.fundWallet = false;
        console.log("long", this.userWallet);
      } catch ({ response }) {
        response.status == 409 ? (this.hasWallet = true) : null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rotate-right {
  display: inline-block;
  transform: rotateZ(90deg);
}
.rotate-back {
  display: inline-block;
  transform: rotateZ(0deg);
}
</style>
